import { useState } from "react";
import { Share2, Download, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { BACKEND_URL } from "@/lib/api";

export default function ShareRideButton({ ride }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const cardUrl = `${BACKEND_URL}/api/rides/${ride.ride_id}/share-card.png`;
  const rideUrl = `${window.location.origin}/ride/${ride.ride_id}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(rideUrl);
      setCopied(true);
      toast.success("Link copiato");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  const shareNative = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: ride.title, text: `Unisciti al mio giro: ${ride.title}`, url: rideUrl });
      } catch { /* user cancelled */ }
    } else {
      copyLink();
    }
  };

  return (
    <>
      <button
        data-testid="ride-share-btn"
        onClick={() => setOpen(true)}
        className="px-6 py-3 border border-gray-300 hover:border-[#E11D48] hover:text-[#E11D48] text-gray-900 rounded-sm font-bold uppercase tracking-wider text-sm flex items-center gap-2 transition-colors"
      >
        <Share2 className="w-4 h-4" /> Condividi
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setOpen(false)}>
          <div onClick={(e) => e.stopPropagation()} className="tactical-card rounded-sm p-6 max-w-lg w-full" data-testid="share-modal">
            <div className="label-tag mb-2">Condividi</div>
            <h3 className="font-display font-bold text-2xl text-gray-900 mb-4">Diffondi il giro</h3>

            <div className="rounded-sm overflow-hidden border border-gray-200 mb-4 bg-black">
              <img src={cardUrl} alt="Anteprima card" className="w-full h-auto" data-testid="share-card-preview" />
            </div>

            <div className="space-y-2">
              <button onClick={shareNative} data-testid="share-native-btn" className="w-full btn-primary py-3 rounded-sm flex items-center justify-center gap-2">
                <Share2 className="w-4 h-4" /> Condividi (WhatsApp, Instagram, ...)
              </button>
              <div className="grid grid-cols-2 gap-2">
                <a href={cardUrl} download={`bicyclub-${ride.ride_id}.png`} data-testid="share-download-btn" className="px-4 py-3 border border-gray-300 hover:border-gray-900 text-gray-900 rounded-sm font-bold uppercase tracking-wider text-sm flex items-center justify-center gap-2">
                  <Download className="w-4 h-4" /> Scarica
                </a>
                <button onClick={copyLink} data-testid="share-copy-btn" className="px-4 py-3 border border-gray-300 hover:border-gray-900 text-gray-900 rounded-sm font-bold uppercase tracking-wider text-sm flex items-center justify-center gap-2">
                  {copied ? <Check className="w-4 h-4 text-green-500" /> : <Copy className="w-4 h-4" />}
                  {copied ? "Copiato" : "Copia link"}
                </button>
              </div>
            </div>

            <button onClick={() => setOpen(false)} data-testid="share-close-btn" className="w-full mt-4 text-xs uppercase tracking-widest text-gray-500 hover:text-gray-900 py-2">Chiudi</button>
          </div>
        </div>
      )}
    </>
  );
}
